import "./ConventionFormSidebar.scss";

export default {
  root: "im-convention-form-sidebar",
  stepper: "im-convention-form-sidebar__stepper",
  description: "im-convention-form-sidebar__description",
  separator: "im-convention-form-sidebar__separator",
  footer: "im-convention-form-sidebar__footer",
};
